import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { i18n, setLocale } from './i18n'
import { installErrorHandlers } from './lib/errorLog'
import './styles/tokens.css'
import './styles/base.css'
import App from './App.vue'

// dev에서는 예전 빌드/preview가 남긴 서비스워커·캐시를 지운다
// (안 지우면 옛 번들이 계속 서빙돼 하드 리프레시로도 코드가 안 바뀜)
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(rs => rs.forEach(r => r.unregister())).catch(() => {})
  if (window.caches) caches.keys().then(ks => ks.forEach(k => caches.delete(k))).catch(() => {})
}

// 초기 <html lang> 동기화
setLocale(i18n.global.locale.value as 'ko' | 'en')

const app = createApp(App)
installErrorHandlers(app) // 런타임 오류를 기기에 쌓는다(서버 전송 없음)
app.use(createPinia()).use(i18n).mount('#app')
